import { useCallback, useMemo, useState } from 'react';
import { useForm } from 'src/components/Form';
import ModalDialog, { ModalCloseHandler } from 'src/components/ModalDialog';
import {
  SolutionSourceImageRepoContainerType,
  SolutionSourceImageRepositoryItem,
} from '../../types';
import { getSourceImageRepositoryFormFields } from '../formFields';

type Props = {
  item?: SolutionSourceImageRepositoryItem;
  title: string;
  loading?: boolean;
  open: boolean;
  onClose: ModalCloseHandler;
  onSubmit: (values: any) => void;
  confirmBtnText?: string;
};

function SolutionSourceImageRepoEditModal({
  item,
  title,
  loading,
  open,
  onClose,
  onSubmit,
  confirmBtnText = 'Save',
}: Props) {
  const [ImagePullSecret, setImagePullSecret] = useState(
    item?.sourcePullSecretPassword || ''
  );
  const [containerType, setContainerType] = useState(
    item?.containerRepositoryType ?? SolutionSourceImageRepoContainerType.Acr
  );

  const handlePaste = () => {
    navigator.clipboard.readText().then((clipboardText) => {
      setImagePullSecret(clipboardText);
      setValue('sourcePullSecretPassword', clipboardText.trim());
    });
  };
  const handleAcrClientSecretPaste = () => {
    navigator.clipboard.readText().then((clipboardText) => {
      setValue('acrClientSecretName', clipboardText.trim());
    });
  };
  const handleEcrSecretKeyPaste = () => {
    navigator.clipboard.readText().then((clipboardText) => {
      setValue('ecrSecretKey', clipboardText.trim());
    });
  };

  const onChange = useCallback(
    ({
      sourcePullSecretPassword,
      containerRepositoryType,
    }: SolutionSourceImageRepositoryItem) => {
      setImagePullSecret(sourcePullSecretPassword ?? '');
      setContainerType(
        containerRepositoryType || SolutionSourceImageRepoContainerType.Acr
      );
    },
    []
  );

  const SOURCE_IMG_CONTAINER_REPO_TYPE_OPTIONS = !item
    ? [
        {
          value: SolutionSourceImageRepoContainerType.Acr,
          label: 'ACR',
          disabled:
            !!item &&
            containerType !== SolutionSourceImageRepoContainerType.Acr,
        },
        {
          value: SolutionSourceImageRepoContainerType.Ecr,
          label: 'ECR',
          disabled:
            !!item &&
            containerType !== SolutionSourceImageRepoContainerType.Ecr,
        },
      ]
    : [
        {
          value:
            containerType === '0'
              ? SolutionSourceImageRepoContainerType.Acr
              : SolutionSourceImageRepoContainerType.Ecr,
          label: containerType === '0' ? 'ACR' : 'ECR',
          disabled: true,
        },
      ];

  const fields = useMemo(
    () =>
      getSourceImageRepositoryFormFields(
        !!item,
        SOURCE_IMG_CONTAINER_REPO_TYPE_OPTIONS,
        ImagePullSecret,
        containerType,
        handlePaste,
        handleAcrClientSecretPaste,
        handleEcrSecretKeyPaste
      ),
    [handlePaste]
  );
  const [form, handleSubmit, setValue] = useForm({
    visibleValuesOnly: true,
    values: item,
    fields,
    onChange,
    onSubmit,
  });

  return (
    <ModalDialog
      open={open}
      title={title}
      confirmBtnText={confirmBtnText}
      onClose={onClose}
      onConfirm={handleSubmit}
      loading={loading}
      fullWidth
    >
      {form}
    </ModalDialog>
  );
}

export default SolutionSourceImageRepoEditModal;
